require("-!style!css!./../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./article.vue")
module.exports = require("-!babel?optional[]=runtime!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./article.vue")
module.exports.template = require("-!html!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./article.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/article.vue
 ** module id = 14
 ** module chunks = 0
 **/